'use strict';

const mmWidgets = require('./mm-widgets'),
	errorDescriptions = {
		'realtime-unavailable': 'Drive Realtime access no longer available',
		'accessDenied': 'Access Denied'
	},
	getStateText = function (fileInfo) {
		if (!fileInfo) {
			return '';
		}
		const state = fileInfo && fileInfo.state,
			errorInfo = (state === 'error') && fileInfo.error && errorDescriptions[fileInfo.error];
		return errorInfo || fileInfo.error || state;
	};
mmWidgets.fn.googleMigrationListItemWidget = function (selectedFile) {
	return mmWidgets.each(this, function () {
		const element = this,
			opener = element.find('[data-mm-role~="openMap"]'),
			stateText = getStateText(selectedFile);
		element.find('[data-mm-role~="description"]').text(selectedFile && selectedFile.fileName);
		element.find('[data-mm-role~="state"]').text(stateText).attr('state', selectedFile && selectedFile.state);
		if (selectedFile && selectedFile.saveConfiguration) {
			opener.attr('href', selectedFile.saveConfiguration.savedUrl);
			opener.removeClass('hidden');
		} else {
			opener.addClass('hidden');
		}
	});
};
